



















































import { Component, Vue } from 'vue-property-decorator'
import { CompanyListDto, findMerchantsList } from "@/api/customerManage";
import SearchNav from "@/components/SearchNav/index.vue";

@Component({
  name: 'AddCustomer',
  components: { SearchNav }
})
export default class AddCustomer extends Vue {
  refreshing = false
  loading = false
  finished = false
  params = {
    keyword: '',
    pageIndex: 1,
    pageSize: 18
  }
  companyList: CompanyListDto[] = []

  // 在添加客户页面，未搜索内容时不展示公司信息列表
  // created() {
  //   this.getList()
  // }
  getList () {
    findMerchantsList(this.params).then(res => {
      this.companyList = res.data.records || []
      if (this.companyList.length >= res.data.totalRecords) {
        this.finished = true;
      } else {
        this.finished = false;
      }
    }).finally(() => {
      this.refreshing = false
    })
  }

  onSearch (val) {
    this.params.keyword = val
    if (this.params.keyword.trim() != '') {
      this.params.pageIndex = 1
      this.getList()
    } else {
      this.$toast('请输入客户名称')
    }
  }

  /**
   * 下拉刷新
   * */
  onRefresh () {
    if (this.params.keyword.trim() != '') {
      this.params.pageIndex = 1
      this.refreshing = true
      this.getList()
    } else {
      this.$toast('请输入客户名称')
      this.refreshing = false
    }
  }

  onLoad () {
    this.params.pageIndex++
    this.loading = true
    findMerchantsList(this.params).then(res => {
      this.companyList = this.companyList.concat(res.data.records)
      // 加载状态结束
      this.loading = false;
      if (this.companyList.length >= res.data.totalRecords) {
        this.finished = true;
      } else {
        this.finished = false;
      }
    }).finally(() => {
      this.refreshing = false
    })
  }

  toDetail (merchantsId: string) {
    this.$router.push({
      path: '/customerDetail',
      query: {
        merchantsId,
        fromPage: 'add' // 添加客户进入详情页
      }
    })
  }

  addCustomer (company: CompanyListDto) {
    this.$router.push({
      path: '/addCustomerNext',
      query: {
        merchantsId: company.companyId,
        merchantsCode: company.companyCode
      }
    })
  }
}
